import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod/v3';

import { menuLayoutRoute } from 'root/MenuLayout';

import {
  poDetailsRouteSearchSchema,
  purchaseOrdersRouteSearchSchema,
  recommendationRouteSearchSchema,
} from './schemas';

const poMainRoute = createRoute({
  getParentRoute: () => menuLayoutRoute,
  path: 'purchase-orders',
  validateSearch: purchaseOrdersRouteSearchSchema.parse,
});

const purchaseOrdersRoute = createRoute({
  getParentRoute: () => poMainRoute,
  path: '/',
  component: lazyRouteComponent(() => import('./views/POs/POsView')),
  validateSearch: purchaseOrdersRouteSearchSchema.parse,
});

const poDetailsRoute = createRoute({
  getParentRoute: () => poMainRoute,
  path: '/$poId',
  component: lazyRouteComponent(() => import('./views/PODetails/PODetailsView')),
  validateSearch: poDetailsRouteSearchSchema.parse,
  parseParams: (params) => ({
    poId: z.string().parse(params.poId),
  }),
});

const recommendationRoute = createRoute({
  getParentRoute: () => poMainRoute,
  path: 'recommendations/$recommendationId',
  component: lazyRouteComponent(() => import('./views/Recommendation/Recommendation')),
  validateSearch: recommendationRouteSearchSchema.parse,
  parseParams: (params) => ({
    recommendationId: z.string().parse(params.recommendationId),
  }),
});

export const poRouteTree = poMainRoute.addChildren({
  purchaseOrdersRoute,
  poDetailsRoute,
  recommendationRoute,
});
